import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodeArrow = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.433571 9.66194C0.500189 9.50077 0.612999 9.3629 0.7578 9.2657C0.902602 9.1685 1.07292 9.1163 1.24732 9.11569L3.74691 9.11028C3.77789 9.11029 3.80807 9.10051 3.83315 9.08232C3.85822 9.06413 3.87689 9.03847 3.88649 9.00902C4.9015 5.90152 6.77067 3.79651 9.06484 3.20235C11.1844 2.6536 13.4844 3.48443 15.5407 5.54068C15.6512 5.65119 15.7133 5.80107 15.7133 5.95735C15.7133 6.11363 15.6512 6.26351 15.5407 6.37402C15.4302 6.48453 15.2803 6.54661 15.124 6.54661C14.9677 6.54661 14.8179 6.48453 14.7074 6.37402C13.7186 5.38527 12.619 5.03568 11.5219 5.36943C10.169 5.77902 9.01484 7.13319 8.43609 8.92611C8.42874 8.94825 8.42678 8.97182 8.43037 8.99487C8.43396 9.01793 8.44299 9.03979 8.45672 9.05865C8.47045 9.07751 8.48848 9.09283 8.50931 9.10333C8.53014 9.11383 8.55318 9.11921 8.5765 9.11902H10.6598C10.8347 9.11897 11.0057 9.17079 11.1511 9.26792C11.2965 9.36506 11.4098 9.50315 11.4768 9.66472C11.5437 9.82628 11.5611 10.0041 11.527 10.1756C11.4928 10.3471 11.4086 10.5046 11.2848 10.6282L6.37317 15.5399C6.26266 15.6504 6.11278 15.7125 5.9565 15.7125C5.80022 15.7125 5.65034 15.6504 5.53983 15.5399L0.625238 10.6253C0.501596 10.5017 0.417392 10.3442 0.383275 10.1727C0.349158 10.0012 0.366661 9.82347 0.433571 9.66194Z",
			fill: "#E9EBF1"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgCodeArrow);
export default ForwardRef;
